"use client"

import clsx from "clsx"

import InlineCta, { type InlineCtaProps } from "~/components/ui/InlineCta"

import { sprinkles } from "~/styles/sprinkles.css"
import { text } from "~/styles/variants"

import * as css from "../styles.css"

function BreadcrumbLinkClient({ isLast = false, ...item }: { isLast?: boolean } & InlineCtaProps) {
  return (
    <li>
      <InlineCta {...item} color="grey-delta" size="tiny" withLine withHover className={css.breadcrumbsLink} />
      <span
        aria-hidden="true"
        className={clsx(
          text({ design: "neue-12", color: "grey-delta" }),
          sprinkles({
            mX: 2,
          })
        )}
      >
        {isLast ? "" : "/"}
      </span>
    </li>
  )
}

export default BreadcrumbLinkClient
